import {
  Box,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogContent,
} from "@mui/material";
import { CheckCircle, CloseOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/Index";

interface RequestSubmittedProps {
  open: boolean;
  onClose: () => void;
  onDone?: () => void;
  amount?: number;
  recipientName?: string;
  lastFourDigits?: string;
}

export default function RequestSubmitted({
  open,
  onClose,
  onDone,
  amount = 10.0,
  recipientName = "Cabs",
  lastFourDigits = "6789",
}: RequestSubmittedProps) {
  const handleDone = () => {
    onDone?.();
    onClose();
  };
  const reduxTheme = useSelector((state: RootState) => state.theme);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          borderColor: reduxTheme.primary_colors?.[400],
          overflow: "hidden",
          m: 2,
          maxWidth: 360,
          width: "100%",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ p: 3 }}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 1,
            }}
          >
            <Box>
              <Typography
                variant="h6"
                sx={{
                  color: reduxTheme.primary_colors?.[400],
                  fontWeight: 700,
                  fontSize: "16px",
                }}
              >
                Request Submitted
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: reduxTheme.primary_colors?.[400],
                  fontSize: "11px",
                  mt: 0.5,
                }}
              >
                We&apos;ll process your request shortly.
              </Typography>
            </Box>
            <IconButton size="small" onClick={onClose}>
              <CloseOutlined fontSize="small" />
            </IconButton>
          </Box>

          {/* Success Icon and Amount */}
          <Box
            sx={{
              textAlign: "center",
              py: 1,
            }}
          >
            <Box
              sx={{
                width: 50,
                height: 50,
                borderRadius: "50%",
                backgroundColor: "#C8E6C9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
              }}
            >
              <CheckCircle
                sx={{
                  fontSize: 32,
                  color: "#4CAF50",
                }}
              />
            </Box>

            <Typography sx={{ fontWeight: 700, mt: 1, fontSize: "16px" }}>
              ${amount.toFixed(2)}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "11px" }}>
              Sending to {recipientName} — ****{lastFourDigits}
            </Typography>
          </Box>

          {/* Info Text */}
          <Box
            sx={{
              borderRadius: 2,
              p: 2,
            }}
          >
            <Typography
              variant="body2"
              sx={{ textAlign: "center", fontSize: "11px" }}
            >
              We&apos;ll process your request shortly and notify you once
              it&apos;s paid.
            </Typography>
          </Box>

          {/* Done Button */}
          <Button
            fullWidth
            variant="contained"
            onClick={handleDone}
            sx={{
              background: `linear-gradient(135deg, ${reduxTheme.primary_colors?.[400]} 0%, ${reduxTheme.primary_colors?.[10]} 100%)`,
              color: reduxTheme.primary_colors?.[900],
              borderRadius: 3,
              py: 1.5,
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: 500,
              boxShadow: "none",
            }}
          >
            Done
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
